<template>
  <transition :appear="appear" name="v-fade-in">
    <div :class="cssClass.modal.parent">
      <div :class="cssClass.modal.inner">
        <div class="c-modal__bg" @click="closeBg"></div>
        <div :class="cssClass.modal.content">
          <Button
            v-if="!notClose && !notCloseBtn"
            class="c-modal__close"
            @click="close"
          >
            <Icon2 color="white" variant="close" :size="18" />
          </Button>
          <div :class="cssClass.box.parent">
            <div v-if="$slots.title" :class="cssClass.box.header">
              <h2 :class="cssClass.box.title"><slot name="title"></slot></h2>
            </div>
            <div :class="cssClass.box.content">
              <h3 v-if="$slots.lead" :class="cssClass.box.lead">
                <slot name="lead"></slot>
              </h3>
              <slot name="content"></slot>
              <div v-if="$slots.btns" :class="cssClass.box.btns">
                <slot name="btns"></slot>
              </div>
            </div>
            <div v-if="$slots.footer" :class="cssClass.box.footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';

export default {
  props: {
    appear: {
      type: Boolean,
      required: false
    },
    notClose: {
      type: Boolean,
      required: false
    },
    notCloseBg: {
      type: Boolean,
      required: false
    },
    notCloseBtn: {
      type: Boolean,
      required: false
    },
    scroll: {
      type: Boolean,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  components: {
    Button,
    Icon2
  },
  computed: {
    cssClass() {
      return {
        modal: {
          parent: {
            'c-modal': true,
            ['c-modal--' + this.variant]: this.variant
          },
          content: {
            'c-modal__content': true,
            ['c-modal--' + this.variant + '__content']: this.variant
          },
          inner: {
            'c-modal__inner': true,
            ['c-modal--' + this.variant + '__inner']: this.variant
          }
        },
        box: {
          parent: {
            'c-modal-box': true,
            'c-modal-box--scroll': this.scroll,
            ['c-modal-box--' + this.variant]: this.variant
          },
          btns: {
            'c-modal-box__btns': true,
            ['c-modal-box--' + this.variant + '__btns']: this.variant
          },
          content: {
            'c-modal-box__content': true,
            ['c-modal-box--' + this.variant + '__content']: this.variant
          },
          footer: {
            'c-modal-box__footer': true,
            ['c-modal-box--' + this.variant + '__footer']: this.variant
          },
          header: {
            'c-modal-box__header': true,
            ['c-modal-box--' + this.variant + '__header']: this.variant
          },
          lead: {
            'c-modal-box__lead': true,
            ['c-modal-box--' + this.variant + '__lead']: this.variant
          },
          title: {
            'c-modal-box__title': true,
            ['c-modal-box--' + this.variant + '__title']: this.variant
          }
        }
      };
    },
    scrollbarSize() {
      return this.$store.state.view.size.scrollbarSize;
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = this.scrollbarSize + 'px';
  },
  beforeDestroy() {
    // スクロールバーの幅分、モーダルが左にずれながら消えるのが気になったので、setTimeoutを使っている
    setTimeout(() => {
      document.body.removeAttribute('style');
    }, 0);
  },
  methods: {
    close() {
      if (this.notClose) {
        return;
      }
      this.$emit('close');
    },
    closeBg() {
      if (this.notCloseBg) {
        return;
      }
      this.close();
    }
  }
};
</script>
